export default __webpack_public_path__ + "static/media/eth-usdtlp.e6a498cd.png";